// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.show-post-quiz__answer{
    width: auto;
    border: 1px solid var(--new-line-color);
    margin: var(--space-half) var(--space);
    padding: var(--space-half);
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
}

.show-post-quiz__answer.correct{
    border: 1px solid var(--new-green-color);
}
.show-post-quiz__answer.wrong{
    border: 1px solid var(--new-warning-color);
}

.show-post-quiz__answer-icon.icon-x{
    color: var(--white-color);
    font-size: calc(var(--space) + var(--space-quarter));
    font-weight: var(--font-bold);
    background: var(--new-warning-color);
    border-radius: 50%;
}

.show-post-quiz__answer-icon.icon-check-single-72{
    color: var(--white-color);
    font-size: calc(var(--space) + var(--space-quarter));
    font-weight: var(--font-bold);
    background: var(--new-green-color);
    border-radius: 50%;
}

.show-post-quiz__answer.baloa-names{
    color: var(--primary-very-dark-color);
}
.show-post-quiz__counter{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: 13px;
    line-height: 15px;
    display: flex;
    align-items: center;
    letter-spacing: 0.004em;
    color: var(--basic-gray-color);

    padding-left: var(--space);
    padding-bottom: var(--space);
}`, "",{"version":3,"sources":["webpack://./src/shared/components/show-post-quiz/ShowPostQuizComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,uCAAuC;IACvC,sCAAsC;IACtC,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,wCAAwC;AAC5C;AACA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,oDAAoD;IACpD,6BAA6B;IAC7B,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,oDAAoD;IACpD,6BAA6B;IAC7B,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;;IAE9B,0BAA0B;IAC1B,4BAA4B;AAChC","sourcesContent":[".show-post-quiz__answer{\n    width: auto;\n    border: 1px solid var(--new-line-color);\n    margin: var(--space-half) var(--space);\n    padding: var(--space-half);\n    border-radius: 8px;\n    display: flex;\n    justify-content: space-between;\n    cursor: pointer;\n}\n\n.show-post-quiz__answer.correct{\n    border: 1px solid var(--new-green-color);\n}\n.show-post-quiz__answer.wrong{\n    border: 1px solid var(--new-warning-color);\n}\n\n.show-post-quiz__answer-icon.icon-x{\n    color: var(--white-color);\n    font-size: calc(var(--space) + var(--space-quarter));\n    font-weight: var(--font-bold);\n    background: var(--new-warning-color);\n    border-radius: 50%;\n}\n\n.show-post-quiz__answer-icon.icon-check-single-72{\n    color: var(--white-color);\n    font-size: calc(var(--space) + var(--space-quarter));\n    font-weight: var(--font-bold);\n    background: var(--new-green-color);\n    border-radius: 50%;\n}\n\n.show-post-quiz__answer.baloa-names{\n    color: var(--primary-very-dark-color);\n}\n.show-post-quiz__counter{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: 13px;\n    line-height: 15px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.004em;\n    color: var(--basic-gray-color);\n\n    padding-left: var(--space);\n    padding-bottom: var(--space);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
